import { FormEvent, useCallback } from 'react';
import { formatDateToLocalStr, formatDateToStr } from '../../../utils/format/formatDate';
import { useTranslation } from '../../../utils/useTranslation';
import { makeRequiredValidator } from '../../../utils/validators/makeRequiredValidator';
import { FormControlGroup } from '../../input/FormControlGroup';
import { Input as InputBase } from '../../input/Input';
import { Radio } from '../../input/Radio';
import { makeTextControlValidate } from '../../input/makeTextControlValidate';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { Wrapper } from './styles';
import { ContentPromotionDateProps, ContentPromotionDateValue } from './types';

const Input = makeTextControlValidate(InputBase);

const validator = makeRequiredValidator<string>();

export const ContentPromotionDate: React.FC<ContentPromotionDateProps> = ({
    value,
    date,
    startDate,
    onChange,
    onChangeDate,
    ...other
}) => {
    const t = useTranslation();
    const checkedChoice = value === ContentPromotionDateValue.CHOICE;
    const onInput = useCallback(
        (event: FormEvent<HTMLInputElement>) => {
            onChangeDate(event.currentTarget.value);
        },
        [onChangeDate],
    );

    return (
        <Wrapper {...other}>
            <Typography variant="title3" weight="bold">
                {t('Дата начала продвижения')}
            </Typography>
            <FormControlGroup mt={3} width="100%" onChange={onChange}>
                <Flex direction="row" alignItems="center">
                    <Radio
                        value={ContentPromotionDateValue.NOW}
                        checked={value === ContentPromotionDateValue.NOW}
                    />
                    <Typography variant="body" ml={2}>
                        {t(`Начиная с ${formatDateToLocalStr(startDate)}`)}
                    </Typography>
                </Flex>
                <Flex direction="row" alignItems="center" mt={3}>
                    <Radio value={ContentPromotionDateValue.CHOICE} checked={checkedChoice} />
                    <Typography variant="body" ml={2}>
                        {t('Выбрать дату')}
                    </Typography>
                </Flex>
                {checkedChoice ? (
                    <Flex width="100%" mt={2}>
                        <Typography variant="caption" color="secondary">
                            {t('Дата начала продвижения')}
                        </Typography>
                        <Input
                            variant="standard"
                            type="date"
                            lang="ru"
                            value={date}
                            min={formatDateToStr(startDate)}
                            onInput={onInput}
                            validator={validator}
                        />
                    </Flex>
                ) : null}
            </FormControlGroup>
        </Wrapper>
    );
};
